export var identity = function identity(x) {
  return x;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/utils/identity.js
// module id = null
// module chunks = 